require("./lib/ads");
var track = require("./lib/tracking");
var paywall = require("./lib/paywall");
setTimeout(() => paywall(10865164), 5000);

require("./bc-preroll");
require("./tabs");
